import moment from 'moment';
import vueGtag from './scripts/vueGtag';
import vuePushEventLog from './scripts/vuePushEventLog';

export default {
  mixins: [vueGtag, vuePushEventLog],
  methods: {
    showNotification(notification) {
      if (notification.displayAs === 'banner') {
        return;
      }

      if (notification.displayAs === 'modal') {
        this.$store.commit('notifications/addNotification', notification);
      } else {
        // turn off new message notification on chat page
        if (notification.type === 'App\\Notifications\\NewMessageNotification' && this.$route.name === 'chat') {
          return;
        }

        if (this.$store.state.settings.isMobile) {
          return;
        }

        // show notification
        this.$notify({
          group: 'custom-template',
          type: notification.status,
          title: notification.title,
          text: notification.text,
          duration: -1,
          data: {
            avatar_url: notification.avatar_url,
            url: notification.url,
          },
        });

        // this.gtag('event', 'notification', {
        //   'event_category': notification.type,
        // });
      }
    }
  },
  created() {
    let vm = this;
    let isAuthenticated = false;
    let isFilled = false;
    /**
     * Load current user and listen for changes
     */
    this.$store.dispatch('user/load')
      .then(function (authenticated) {
        isAuthenticated = authenticated;
        if (!authenticated) {
          return false;
        }

        isFilled = !!vm.$store.state.user.user.filled_at;
        if (!isFilled) {
          return false;
        }

        Echo.private('user.' + vm.$store.state.user.user.id)
          .listen('UserUpdate', (event) => {
            vm.$store.commit('user/setUser', event.user);
          })
          // .listen('NewMessageEvent', (event) => {
          //     vm.$store.commit('user/setUserUnreadMessagesCount', event.unread_messages_count);
          // })
          .notification((notification) => {
            if (notification.type === 'App\\Notifications\\NewMessageNotification') {
              vm.$store.commit('user/setUserUnreadMessagesCount', notification.unread_messages_count);
            }

            if (notification.type === 'App\\Notifications\\ProfileVisitedNotification') {
              vm.$store.commit('user/setUserUnseenVisitorCount', notification.unseen_visitor_count);
            }

            vm.showNotification(notification);
          });

        vm.$eventHub.$emit('UserLoaded', { user_id: vm.$store.state.user.user.id });
        vm.$store.dispatch('notifications/load');

        vm.afterUserLoaded(vm.$store.state.user.user.id);
      });

    /**
     * Refresh data
     */
    setInterval(() => {
      if (isAuthenticated && isFilled) {
        this.$store.dispatch('profiles/loadOnline');
        this.$store.dispatch('profiles/loadMatches');
      }
    }, 15 * 60 * 1000);

    setInterval(() => {
      if (isAuthenticated && isFilled) {
        this.$store.dispatch('profiles/loadChatOnline');
      }
    }, 25 * 60 * 1000);

    /**
     * Daily reward
     */
    if (window.appVersionCode >= 108)
      vm.$eventHub.$on('UserLoaded', function ({ user_id }) {
        const today = moment().format('YYYYMMDD');

        if (!this.globals.site.enabled_daily_rewards || window.localStorage.getItem('last-daily-reward.' + user_id) === today) {
          return;
        }

        return axios
          .get(zRoute('ajax.daily_rewards.index'))
          .then(response => {
            if (response.data.popup) {
              vm.$store.commit('notifications/addNotification', response.data.popup);
              window.localStorage.setItem('last-daily-reward.' + user_id, today);
            }
          })
          .catch(error => {
            if (error.response.data.reason === vm.globals.actions.ACTION_DAILY_REWARD_RECEIVED) {
              window.localStorage.setItem('last-daily-reward.' + user_id, today);
            }
          });
      });
  }
};

